import app from './app'
import apiKeys from './apiKeys'

export default {
    app,
    apiKeys,
}
